<template>
  <section class="rounded-md border border-gray-200 p-2.5">
    <div class="flex items-start justify-between gap-2">
      <p class="font-semibold text-sm text-gray-900">{{ title }}</p>
      <button type="button" class="text-primary-dark underline text-xs font-medium" @click="$emit('edit')">
        Modifier
      </button>
    </div>
    <slot />
  </section>
</template>

<script>
export default {
  emits: ["edit"],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
